import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { QuestionsTrueFalseConfig } from '@core/models/built/procedure-step-config.model';
import { ProcedureStep } from '@core/models/procedures.model';
import { FlowchartMode } from '@flowchart';
import { TranslocoService } from '@ngneat/transloco';
import { BehaviorSubject } from 'rxjs';
import { arrayMinLength } from 'src/app/utils/form-validators/array-min-length.validator';

import it from './i18n/questions-true-false-edit.it.json';

@Component({
  templateUrl: './questions-true-false-edit.component.html',
})
export class QuestionsTrueFalseEditComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('questionInput') questionInput!: ElementRef;

  @Input() step?: ProcedureStep;
  @Input() mode: FlowchartMode = 'edit';
  @Input() editForm!: FormGroup;

  private questions$$ = new BehaviorSubject<string[]>([]);
  questions$ = this.questions$$.asObservable();

  constructor(
    private fb: FormBuilder,
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit() {
    const config = this.step?.config as QuestionsTrueFalseConfig;

    const configGroup = (this.editForm.get('config') as FormGroup);
    if (configGroup) {
      configGroup.addControl('questions', this.fb.control(config?.questions || [], [arrayMinLength(1)]));
    } else {
      this.editForm.addControl('config', this.fb.group({
        questions: this.fb.control(config?.questions || [], [arrayMinLength(1)])
      }));
    }

    this.questions$$.next(config?.questions || []);

    if (this.mode === 'view') {
      (this.editForm.get('config') as FormGroup).disable();
    }
  }

  ngAfterViewInit() {
    if (this.mode === 'edit' && this.questionInput) {
      this.questionInput.nativeElement.value = '';
    }
  }

  ngOnDestroy() {
    const configGroup = (this.editForm.get('config') as FormGroup);
    if (configGroup) {
      configGroup.removeControl('questions');

      if (Object.keys(configGroup.controls).length <= 0) {
        this.editForm.removeControl('config');
      }
    }
  }

  addQuestion(value?: string) {
    if (value) {
      const questions: string[] = [...new Set([...this.questions$$.getValue(), value])];
      this.questions$$.next(questions);
      const ctl = (this.editForm.get('config.questions') as FormControl);
      ctl.setValue(questions);
      ctl.markAsTouched();
      this.questionInput.nativeElement.value = '';
    }
  }

  removeQuestion(value: string) {
    const questions: string[] = this.questions$$.getValue().filter(a => a !== value);
    this.questions$$.next(questions);
    const ctl = (this.editForm.get('config.questions') as FormControl);
    ctl.setValue(questions);
    ctl.markAsTouched();
    this.questionInput.nativeElement.value = '';
  }

}
